import React from 'react'
import injectSheet from 'react-jss'
import styles from './contributor.styles'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'

const Contributor = ({ classes, id, name, avatar }) => {
  return (
    <div className={classes.container}>
      <PobbleAvatar avatar={avatar} name={name} className={classes.avatar} />
      <span className={classes.name}>{name}</span>
    </div>
  )
}

export default injectSheet(styles)(Contributor)
